/* eslint-disable no-unused-vars */
export enum ESmallFleetOrderStatus {
    PENDING = 'PENDING',
    ASSIGNED = 'ASSIGNED',
    LOST = 'LOST',
}
